import ReviewsSummary from '@ui/Product/Summary/ReviewsSummary/component'

export default (): void => {
  ReviewsSummary()
}
